// 海鸥地址
export const haiouUrlMap = {
  test: 'http://haiou.it.test.sankuai.com',
  st: 'http://haiou.it.st.sankuai.com',
  prod: 'https://haiou.sankuai.com',
};

// 埋点
export const LX = {
  MC: {
    COMPUNTER: 'b_ead_7n66m824_mc',
  },
  PID: 'c_ead_76nm3o19',
};

// 电子签
export const SignSystemUrlMap = {
  prod: 'https://sign.meituan.com',
  st: 'https://sign.it.st.meituan.com',
  test: 'http://wbliaowenwu-tdbfa-sl-sign.it.test.sankuai.com',
};
export enum PoliticalStatusDictIndex {
  // 中国共产党预备党员
  CCPProbationaryMember = '000',
  // 中国共产党党员
  MemberOfTheCPC = '001',
  // 中国共产主义青年团团员
  CommunistYouthLeagueMember = '002',
  // 群众
  Masses = '003',
  // 中国国民党革命委员会党员
  RevolutionaryCommitteeOfChineseKuomintang = '004',
  // 中国民主同盟盟员
  ChinaDemocraticLeague = '005',
  // 中国民主建国会会员
  ChinaDemocraticNationalConstructionAssociation = '006',
  // 中国民主促进会会员
  ChinaAssociationForPromotingDemocracy = '007',
  // 中国农工民主党党员
  ChinaPeasantsAndWorkersDemocraticParty = '008',
  // 中国致公党党员
  ChinaZhiGongParty = '009',
  // 九三学社社员
  JiusanSociety = '010',
  // 台湾民主自治同盟盟员
  TaiwanDemocraticSelfGovernmentLeague = '011',
  // 无党派人士
  NonPartisanPersons = '012',
  // 其他
  Others = '013',
}
